import { OperationType, ROUTE_PATH } from "common/constants/sm-constants";
import { WidgetModel } from "common/models/utility-models/base-model";
import { GridPostParams } from "common/models/utility-models/list-utility.model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";




export class StudentsGridParams extends GridPostParams {
    pageNumber: 1;
    pageSize: 10;
    searchText: '';
    direction: '';
    column: ''
}

export class StudentsGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Students',
            ROUTE_PATH.studentsGrid,
            ROUTE_PATH.add_student,
            false,
            false,
            7,
            true,
            true,
            ['studentName', 'region', 'branch_name', 'batch_name', 'status'],
            false,
            [],
            { isDownloadExcel: true, excelFileName: 'Students List' + new Date().toLocaleDateString() + '.xlsx', btnLabel: 'Download Students List', headers: [
                { key: 'First Name', value: 'first_name' },
                { key: 'Last Name', value: 'last_name' },
                { key: 'Father Name', value: 'father_name' },
                { key: 'Mother Name', value: 'mother_name' },
                { key: 'Mobile Number', value: 'mobile_number' },
                { key: 'Email', value: 'email' },
                { key: 'Gender', value: 'gender' },
                { key: 'Address', value: 'address' },
                { key: 'Age', value: 'age' },
                { key: 'DOB', value: 'date_of_birth' },
                { key: 'State', value: 'stateName' },
                { key: 'District', value: 'district' },
                { key: 'Region', value: 'region' },
                { key: 'College Name', value: 'name_of_college' },
                { key: 'College Address', value: 'college_address' },
                { key: 'Branch Name', value: 'branch_name' },
                { key: 'Branch Category', value: 'branchCatName' },
                { key: 'Batch Name', value: 'batch_name' },
                { key: 'Duration Start', value: 'duration_start' },
                { key: 'Duration End', value: 'duration_end' },
                { key: 'Unique Batch ID', value: 'unique_batch_id' },
                { key: 'Summer Vacation Start Date', value: 'summer_vacation_start_date' },
                { key: 'Summer Vacation End Date', value: 'summer_vacation_end_date' },
                { key: 'Winter Vacation Start Date', value: 'winter_vacation_start_date' },
                { key: 'Winter Vacation End Date', value: 'winter_vacation_end_date' },
                { key: 'First Year Credit', value: 'first_year_credit' },
                { key: 'First Year 2 Credit', value: 'first_year2_credit' },
                { key: 'Second Year Credit', value: 'second_year_credit' },
                { key: 'Second Year 2 Credit', value: 'second_year2_credit' },
                { key: 'Third Year Credit', value: 'third_year_credit' },
                { key: 'Third Year 2 Credit', value: 'third_year2_credit' },
                { key: 'Fourth Year Credit', value: 'fourth_year_credit' },
                { key: 'Fourth Year 2 Credit', value: 'fourth_year2_credit' },
                { key: 'Fifth Year Credit', value: 'fifth_year_credit' },
                { key: 'Fifth Year 2 Credit', value: 'fifth_year2_credit' },
                { key: 'First Year Score', value: 'first_year_score' },
                { key: 'First Year 2 Score', value: 'first_year2_score' },
                { key: 'Second Year Score', value: 'second_year_score' },
                { key: 'Second Year 2 Score', value: 'second_year2_score' },
                { key: 'Third Year Score', value: 'third_year_score' },
                { key: 'Third Year 2 Score', value: 'third_year2_score' },
                { key: 'Fourth Year Score', value: 'fourth_year_score' },
                { key: 'Fourth Year 2 Score', value: 'fourth_year2_score' },
                { key: 'Fifth Year Score', value: 'fifth_year_score' },
                { key: 'Fifth Year 2 Score', value: 'fifth_year2_score' },
                { key: 'Mentor Name', value: 'mentor_name' },
                { key: 'Mentor Email', value: 'mentor_email' },
                { key: 'Mentor Mobile', value: 'mentor_mobile' },
                { key: 'Parent Mobile Number', value: 'parentMobileNumber' },
                { key: 'Status', value: 'statusName' }
            ] },
            false,
            null,
            false,
            null,
            null,
            null,
            { evalKey: 'wantToDelete', evalParam: [1], decisiveParam: false },
            null,
            null,
            {
                isPreview: false,
                isPreviewType: '',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            false,
            true,
            true,
            [],
            false,
            {
                isExtraActions: false,
                btnLabel: '',
                selectOptions: [],
                selectedValue: '',
            },
            {
                isCheckboxEmit: false,
                emitKey: '',
                checkedKey: '',
                valueKey: '',
            },
            {
                isDownload: false,
                key: '',
                valueKey: '',
            },
            {
                isTabStatus: false,
                label: '',
                isChecked: false,
            },
            false,
            false,
            {
                isPrimary: true,
                isDanger: false,
              },
              '',
              { value: '', isVisible: false },
              false,
              false,
              true,
              {
                isExtraActions: false, 
                btnLabel: '',
                selectOptions: [],
                selectedValue: '',
                isPreviewBtn: true,
                previewBtnLabel: 'Import List',
            },
              { value: '', isVisible: false },
              true
        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const studentName = new Headers('Student Name', 'studentName', true, true, 'text', '0', { isColumnNavigation: true, navigationUrl: ROUTE_PATH.studentDetails, navigateOperationType: OperationType.UPDATE, navigateTransferData: new WidgetModel() });
        const emailId = new Headers('Email ID', 'email', false, true, 'textUrl');
        const branch = new Headers('Main Branch ', 'branch_name', true, true, 'text');
        const batch = new Headers('Batch ', 'batch_name', true, true, 'text');
        // const batchId = new Headers('Batch ID', 'batch_id', false, true, 'number');
        const region = new Headers('Region', 'region', false, true, 'text');
        const status = new Headers('Status', 'status', true, true, 'text', '0', {
            isColumnNavigation: false,
            navigationUrl: null,
            navigateOperationType: null,
            navigateTransferData: {}
        }, null, { isToggle: true, toggleKey: 'status', toggleCheckedValue: true, toggleUncheckedValue: false });
        const terminate = new Headers('', 'terminate', false, false, 'terminate', '0');

        headers.push(studentName);
        headers.push(emailId);
        headers.push(branch);
        headers.push(batch);
        // headers.push(batchId);
        headers.push(region);
        headers.push(status);
        headers.push(terminate);
        return headers;
    }
}